import * as yup from 'yup'

const schema = yup.object().shape({
  email: yup.string().email('E-mail inválido').required('Campo obrigatório'),
  name: yup.string().required('Campo obrigatório'),
  cell_phone: yup.string().required('Campo obrigatório'),
})

export { schema }
